import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'slotFilter'
})
export class SlotFilterPipe implements PipeTransform {

  transform(slots: any[], shifts: any[]): any[] {
    var newSlots = []
    
    slots.forEach(slot => {
      
      var inShift = false
      
      shifts.forEach(shift => {
        if (slot.start >= shift.start && slot.start < shift.start + shift.duration) inShift = true
      })

      if (!inShift) newSlots.push(slot)

    })

    return newSlots
  }

}
